import React from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center z-50">
      <div
        className="absolute inset-0 bg-gray-500 opacity-50"
        onClick={onClose}
      ></div>
      <div className="relative w-11/12 md:w-full max-w-xl p-8 bg-white rounded-lg shadow-lg outline-none mx-auto my-8 z-50">
        <div className="max-h-[70vh] overflow-y-auto text-left">{children}</div>
        <div className="flex justify-end mt-3">
          <button
            className="w-full bg-gray-500 text-white py-2 rounded hover:bg-gray-600 transition-colors"
            onClick={onClose}
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
